import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;

type Props = {
  isOpen: boolean;
  isResubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ResubmitConfirmDialog = ({
  isOpen,
  isResubmitting,
  onClose,
  onConfirm,
}: Props) => {
  const { t } = useResource();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm">
      <DialogTitle>{t(RESOURCES.ResubmitConfirmTitle)}</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mt: 1 }}>
          {t(RESOURCES.ResubmitConfirmText)}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isResubmitting}>
          {t(RESOURCES.ResubmitCancelButton)}
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          disabled={isResubmitting}
          startIcon={
            isResubmitting ? <CircularProgress size={16} /> : <RefreshIcon />
          }
        >
          {t(RESOURCES.ResubmitConfirmButton)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
